<template>
    <div class="u-d-flex" :class="{'u-r-flex-wrap' : isRouteByName('mini-calculators')}" v-if="tooltipText || theCurrentWidth > 1024">
        <div class="c-icon-tooltip__container" :class="[tooltipName, iconType]" v-bind:style="{ width: containerWidth + pixelOrPercent }" @mouseover="iconEnter" @mouseleave="iconLeave">
            <svg v-if="!noIcon && tooltipText" viewBox="0 0 120 120" class="m-icon m-icon--small m-icon--no-hover open" :class="iconColour" :style="hoverStyle">
                <use :xlink:href="'#' + iconType"></use>
            </svg>
            <svg focusable="false" v-else viewBox="0 0 120 120" class="m-icon m-icon--small m-icon--no-hover open" :class="iconColour" :style="hoverStyle">
                <use :xlink:href="'#' + iconType"></use>
            </svg>
            <div v-show="tooltipVisible" class="c-icon-tooltip__text" :class="'c-icon-tooltip__' + side"
                v-bind:style="{ width: textWidth + 'px' }">
                {{tooltipText}}
            </div>
            <slot></slot>
        </div>
        <div class="c-icon-tooltip__responsive-text">{{tooltipText}}</div>
    </div>
</template>

<script>

    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: 'icon-tooltip',
        props: {
            tooltipName: {
                type: String,
                default: null
            },
            tooltipText: {
                type: String,
                default: null
            },
            side: {
                type: String,
                default: null
            },
            containerWidth: {
                type: String,
                default: '26'
            },
            textWidth: {
                type: String,
                default: '200'
            },
            iconType: {
                type: String,
                default: null
            },
            noIcon: {
                type: Boolean,
                default: false
            },
            pixelOrPercent: {
                type: String,
                default: 'px'
            },
            iconColour: {
                type: String,
                default: 'm-icon--dark'
            }
        },
        data: function () {
            return {
                tooltipVisible: false,
                hoverStyle: {}
            }
        },
        computed: {
            ...mapGetters('windowWidth', ['theCurrentWidth'])
        },
        methods: {
            ...mapActions('windowWidth', ['updateWidth']),
            iconEnter(e) {
                if(this.tooltipText && this.theCurrentWidth > 1024 && !e.currentTarget.classList.contains('default')) {
                    this.hoverStyle = {
                        cursor: 'pointer'
                    };
                    this.tooltipVisible = true;
                }
            },
            iconLeave() {
                document.body.style.cursor = "auto";
                this.tooltipVisible = false;
            },
            isRouteByName (routeName) {
                return this.$route.name == routeName;
            },
        },
        mounted() {
            this.updateWidth(window.innerWidth);
        },
    }

</script>

<style lang="scss">
    @import '../assets/sass/base/colours.scss';
    @import '../assets/sass/base/sizing.scss';
    @import '../assets/sass/view/component/icon-tooltip.scss';
</style>


// WEBPACK FOOTER //
// IconTooltip.vue?8440bbca